export const CAMBIAR_FROM_SOLICITUD = "CAMBIAR_VIEW_FROM_SOLICITUD";
export const ACTUALIZAR_SOLICITUD = "ACTUALIZAR_SOLICITUD";
export const MODIFICAR_FILTROS_SOLICITUD = "MODIFICAR_FILTROS_SOLICITUD";
export const CARGANDO_CONTROL_SOLICITUD = "CARGANDO_CONTROL_SOLICITUD";
export const REINICIAR_FILTROS_SOLICITUD = "REINICIAR_FILTROS_SOLICITUD";
export const SELECCIONAR_SOLICITUD = "SELECCIONAR_SOLICITUD"; 
export const NOTIFICACION = "NOTIFICACION";